export default ({ app }, inject) => {
  inject('replaceLineBreaks', (string) => {
    if (!string) return null
    return string.split('\n').join('<br>')
  })
}
